import { Instance } from 'mobx-state-tree'
import { PlayerGroupModelBase } from './PlayerGroupModel.base'

/* The TypeScript type of an instance of PlayerGroupModel */
export interface PlayerGroupModelType extends Instance<typeof PlayerGroupModel.Type> {}

/* A graphql query fragment builders for PlayerGroupModel */
export { selectFromPlayerGroup, playerGroupModelPrimitives, PlayerGroupModelSelector } from './PlayerGroupModel.base'

/**
 * PlayerGroupModel
 */
export const PlayerGroupModel = PlayerGroupModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
